// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__3idT9","home__svg":"Home_home__svg__diFn1","home__buttons":"Home_home__buttons__2wUtE","home__modal__container":"Home_home__modal__container__3h2Yg"};